<template>
  <v-row
    class="ma-0 d-inline-flex"
    v-if="
      product.AvailabilityBatchGroup != null &&
      product.AvailabilityBatchGroup.BatchGroupId != 0
    "
  >
    <v-col class="pa-0 px-2 pb-2 text-wrap">
      <span class="details-label">
        <v-icon size="22" color="blue">mdi-information-outline</v-icon>
        {{ $translate('PRODUCT_AVAILABILITY') }}
        {{ product.AvailabilityBatchGroup.Description }}
      </span>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'ProductAvailabilityDetails',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    item() {
      this.init();
    },
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      product: {},
    };
  },
  methods: {
    init() {
      if (this.item != null) this.product = this.item;
    },
  },
};
</script>
<style>
.details-label {
  display: inline;
  color: rgb(29, 145, 233);
  padding: 0px 1px 1px 1px;
  font-size: 16px;
  align-content: center;
}
</style>
